export let QuestionTypes = /*#__PURE__*/function (QuestionTypes) {
  QuestionTypes["RADIO"] = "radio";
  QuestionTypes["TEXTFIELD"] = "textfield";
  QuestionTypes["REPEATABLE_TEXTFIELD"] = "repeatable_textfield";
  QuestionTypes["THIRD_PARTY_ENTITY_QUESTION"] = "third_party_entity_question";
  QuestionTypes["DATA_RETENTION_QUESTION"] = "data_retention_question";
  QuestionTypes["COUNTRY_SELECT"] = "country_select";
  QuestionTypes["CHECKBOX"] = "checkbox";
  QuestionTypes["REPEATABLE_CREATABLE_SELECT"] = "repeatable_createable_select";
  QuestionTypes["IN_SOURCED"] = "in_sourced";
  QuestionTypes["DATA_PROCESSED_AND_STORED"] = "data_processed_and_stored";
  QuestionTypes["TYPES_PROCESSED_AND_STORED_CHECK"] = "types_processed_and_stored_check";
  QuestionTypes["DATA_RETENTION_INDEFINITE"] = "data_retention_indefinite";
  return QuestionTypes;
}({});
export let HELPER_MESSAGE_TYPES = /*#__PURE__*/function (HELPER_MESSAGE_TYPES) {
  HELPER_MESSAGE_TYPES["TEXT"] = "text";
  HELPER_MESSAGE_TYPES["LINK"] = "link";
  HELPER_MESSAGE_TYPES["TOOLTIP"] = "tooltip";
  return HELPER_MESSAGE_TYPES;
}({});